<template>
  <div class="content-progress">
    <p class="date-info" v-show="flightData.progress.fligthTime">
      <span>({{localizeList.travelTimeTitle}}:</span>
      {{flightData.progress.fligthTime}})
    </p>
    <div class="avia-flight-container">
      <div class="line" :style="[{'width': lineWidth}]"></div>
      <div class="avia-flight-info">
        <div class="avia-flight-item" v-for="(item, key) in getFlightData" :key="key">

          <template v-if="item.progress">
          <div class="avia-flight-progress"> 
            <div class="circle"></div>

            <div class="progress" :style="[{'width': getProgressWidth(item.progress)}]">
              <div class="progress-line-empty"></div>
              <div class="progress-line"></div>
            </div>

            <div class="circle"></div>
          </div>
          </template>

          <template v-else>
            <div :class="['circle', {'first': key === 0}, {'last': key === getFlightData.length - 1}]"></div>
          </template>

          <p class="text"
          @mouseenter="$emit('showPopover', item.fullString, $event)"
          @mouseleave="$emit('hidePopover')"
          >
          <span class="flight-text" v-if="key === 1 && getProgressItems.length > 2">
          {{ getProgressItems.length > 3 ? localizeList.transfersUpper : localizeList.transferUpper }}
          </span>
          <span>{{item.code}} </span>
          <span v-show="getProgressItems[key].time">({{getProgressItems[key].time}})</span> 
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "AviaFlightInfo",

  props: {
    flightData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      lineWidth: "100%"
    }
  },

  computed: {
    getProgressItems(){
      return this.flightData.progress.items
    },

    getFlightData(){ 
      const segments = this.allSegments;
      let airportData = []

      airportData = Array.from({ length: segments.length + 1}).map((item, idx) => {
        const prev = idx - 1;

        if(!item) item = {}

        if(idx === 0){
          item.city = segments[idx].departureCity;
          item.country = segments[idx].departureCounty;
          item.airport = segments[idx].departureAirport;
          item.code = segments[idx].departureAirportCode;
          item.time = moment(segments[idx].departureDate).format('HH:mm');
          item.fullString = `${this.localizeList.departureFromAirport}
          <br> 
          "${item.airport}" (${item.city}/${item.country})
          <br>
          ${this.localizeList.in} ${item.time} ${this.localizeList.byLocalTime}`;
          return item
        } else if (idx !== segments.length){
          item.city = segments[prev].arrivalCity;
          item.country = segments[prev].arrivalCounty;
          item.airport = segments[prev].arrivalAirport;
          item.code = segments[prev].arrivalAirportCode;
          item.progress = segments[idx].progress[idx].time;
          item.fullString = `${this.localizeList.changeAircraft} ${item.progress} 
          <br>
          ${this.localizeList.in} ${this.localizeList.airport} "${item.airport}"
          <br>
          (${item.city}/${item.country})`;
          return item 
        } else {
          item.city = segments[prev].arrivalCity;
          item.country = segments[prev].arrivalCounty;
          item.airport = segments[prev].arrivalAirport;
          item.code = segments[prev].arrivalAirportCode;
          item.time = moment(segments[prev].arrivalDate).format('HH:mm');
          item.fullString = `${this.localizeList.arrivalInAirport} 
          <br>"${item.airport}" (${item.city}/${item.country}) 
          <br>${this.localizeList.in} ${item.time} ${this.localizeList.byLocalTime}`;
          return item 
        }
      })

      return airportData
    },

    allSegments(){
      const all = this.flightData.allSegments;
      const modified = all.map((item) => ({
        departureCity: item.depratureCity.mtItem.name,
        departureCounty: item.depratureCity.mtItem.columnValues.at(-1),
        departureAirport: item.departureAirport.mtItem.name,
        departureAirportCode: item.departureAirport.mtItem.code,
        departureDate: item.departureDate,
        arrivalCity: item.arrivalCity.mtItem.name,
        arrivalCounty: item.arrivalCity.mtItem.columnValues.at(-1),
        arrivalAirport: item.arrivalAirport.mtItem.name,
        arrivalAirportCode: item.arrivalAirport.mtItem.code,
        arrivalDate: item.arrivalDate,
        progress: this.flightData.progress.items
      }))
      return modified
    } 
  },

  methods: {
    getProgressWidth(progress){
      const lineWidth = 350;
      const fligthTime = this.strTimeToMin(this.flightData.progress.fligthTime)
      const currentTime = this.strTimeToMin(progress)
      const percent = Math.round((currentTime / fligthTime) * 100)
      const width = (lineWidth * percent) / 100;
      return width + 'px'
    },

    strTimeToMin(str){
      if(str.split(' ').length === 2) {
        const [hour, min] = str.split(' ')
        const sum = parseInt(hour) * 60 + parseInt(min)
        return sum
      } 
      return parseInt(str)
    },
  },
}
</script>

<style scoped>

.avia-flight-container {
  margin: 0 30px;
  position: relative;
}

.avia-flight-info {
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
}

.avia-flight-progress {
  display: flex;
  flex-direction: row;
}

.avia-flight-info .avia-flight-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.avia-flight-info .circle {
  width: 9px;
  height: 9px;
  border: 1px solid black;
  border-radius: 100%;
  margin: 0 0 10px 0;
  background: white;
  /* box-shadow: 0 0 0 11px white; */
}
.avia-flight-info .circle.first {
  margin: 0 auto 10px 0;
}
.avia-flight-info .circle.last {
  margin: 0 0 10px auto;
}

.content-progress .date-info {
  white-space: nowrap;
  font-size: 14px;
  text-transform: lowercase;
}

.content-progress .date-info {
  font-size: 12px;
  white-space: nowrap;
  text-align: center;
  margin-bottom: 8px;
  padding-top: 8px;
}
.content-progress .date-info .bold-text {
  font-weight: bold;
}

.avia-flight-info .text {
  font-size: 12px;
  font-weight: bold;
}

.avia-flight-container .line {
  width: 100%;
  height: 0.05rem;
  background-color: black;
  position: absolute;
  top: 4px;
}

.progress {
  width: 50px;
  position: relative;
}

.progress-line {
  width: 100%;
  height: 0.05rem;
  position: absolute;
  top: 4px;
  background-image: linear-gradient(90deg, #000, #000 75%, transparent 75%, transparent 100%);
  background-size: 10px 1px;
  border: none;
}

.progress-line-empty {
  width: 100%;
  height: 0.05rem;
  background-color: white;
  position: absolute;
  top: 4px;
}

.flight-text {
  margin-right: 5px;
}
</style>